<template>
  <div class="email-verify-completed my-5 d-flex align-items-center justify-content-between">

    <div>
      {{$t('verification.verifyEmail')}}
    </div>

    <div>
      <i class="far fa-check"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailVerifyCompleted',
}
</script>


<style lang="scss" scoped>
.email-verify-completed {
  background: #ffffff;
  border: 1px solid #e5eaee;
  box-sizing: border-box;
  border-radius: 6px;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 25px;
  color: #212121;
  padding: 20px;
  i {
    font-style: normal;
    font-weight: normal;
    font-size: 35px;
    line-height: 35px;
    color: #00baf2;
  }
}
</style>